/* global axios */
import ApiClient from '../ApiClient';

// M26.2.1 (round 2) — thin client for Nexceo::Ai::WorkforceActivityService,
// exposed via WorkforceActivityController. No aggregation logic here.
class NexceoWorkforceActivityAPI extends ApiClient {
  constructor() {
    super('nexceo/workforce_activity', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new NexceoWorkforceActivityAPI();
